export default __webpack_public_path__ + "static/media/background.c4cc4d24.jpg";